















import {Component, Vue} from 'vue-property-decorator';
import PlanEditResultConfigFlexGridEditDialog from './PlanEditResultEditConfigFlexGridEditDialog.vue';
import PlanEditResultEditConfigFlexGrid from '@/views/journals/planEdit/planEditTabs/result/edit/PlanEditResultEditConfigFlexGrid.vue';

@Component({
    components: {PlanEditResultEditConfigFlexGrid},
})
export default class PlanEditResultEditDialog extends Vue {
    private dialog = false;
    private editDialog = PlanEditResultConfigFlexGridEditDialog;
    public setIsEditing!: Function;

    open() {
        this.dialog = true;
    }
    close() {
        this.dialog = false;
    }
}
